<div class="message-container" *ngIf="showNoResult">
  <div class="no-data-label message">
    {{ T_SCOPE + '.no-results' | translate }}
  </div>
</div>
